import { selectChangeMessageForStaticHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForStaticHtmlString';
import { selectImageNode } from '@newStore/documentUI/transformContent/imageSelectors';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { imageAlt, imageComponent } from '@nodeTypeConfig/helpers/editComponents/imageComponent';

const IMAGE: BuildingBlockNodeConfig = {
  nodeSelector: selectImageNode,
  information: {
    single: 'Afbeelding',
    plural: 'Afbeeldingen',
    ribonIcon: require('../../../../img/buildingBlocks/IMAGE.svg'),
  },

  buildingBlocks: [],
  edit: [
    {
      ...imageComponent,
      required: RequiredType.ERROR,
      options: {
        ...imageComponent.options,
        fields: imageAlt,
      },
    },
    {
      component: 'title',
      reactComponent: 'AsideTitle',
      asideChangeMessageSelector: selectChangeMessageForStaticHtmlString,
      property: 'description',
      label: 'Bijschrift',
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default IMAGE;
